import React,{ Component } from 'react';
import { Collection, CollectionItem,Icon } from 'react-materialize';

export default class ChartEditorMenu extends Component {

    constructor(props){
        super(props);
    }
    setMenuActive(menu){
        this.props.setMenuActive(menu);
    }
    render(){
        return <Collection>
                <CollectionItem 
                    href='#' 
                    active={this.props.menuActive == 'data'}
                    onClick={this.setMenuActive.bind(this,'data')}>
                    <Icon center>poll</Icon><p style={{margin:0}}>Data</p>
                </CollectionItem>
                <CollectionItem 
                    href='#' 
                    active={this.props.menuActive == 'settings'}
                    onClick={this.setMenuActive.bind(this,'settings')}>
                    <Icon center>settings</Icon><p style={{margin:0}}>Settings</p>
                </CollectionItem>
                <CollectionItem 
                    href='#' 
                    active={this.props.menuActive == 'colors'}
                    onClick={this.setMenuActive.bind(this,'colors')}>
                    <Icon center>color_lens</Icon><p style={{margin:0}}>Color</p>
                </CollectionItem>
            </Collection>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/ChartEditorMenu.jsx